import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  cuentaContable12EUR: Yup.string()
    .max(12)
    .notRequired(),
  cuentaContable12PEN: Yup.string()
    .max(12)
    .notRequired(),
  cuentaContable12USD: Yup.string()
    .max(12)
    .notRequired(),
  cuentaContablePercepcion: Yup.string()
    .max(12)
    .notRequired()
})
